import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/app/catering-services/components/CateringServicesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/components/ui/AppImage.tsx");
